<bb-page-header [backOnMobile]="['/library/social']" [icon]="'youtube'" [title]="entity?.name" [tabItems]="tabItems">

	<bb-status *ngIf="entity" valueOn="active" valueOff="inactive" [labelOn]="activeLabel" [labelOff]="inactiveLabel" [(ngModel)]="entity.status" name="status"></bb-status>

</bb-page-header>

<form #formRef="ngForm" class="social-details" cdkScrollable>
	<div class="container">
		<div class="column">
			<social-details-youtube *ngIf="activeTab === 'general'" [entity]="entity"></social-details-youtube>
			<social-details-automated-syncing *ngIf="activeTab === 'automated-synching'" [(entity)]="entity" [bbTableService]="bbTableService" [form]="form" [rows]="rows" (queryStringChange)="queryChangedCheck($event)" (rowsChanged)="rowsChanged($event)"></social-details-automated-syncing>
		</div>

		<div class="column preview">
			<div [hidden]="activeTab === 'automated-synching'" class="filter"><span>show</span><bb-select [(ngModel)]="filterOption" [options]="filterOptions" (ngModelChange)="filterChanged($event)" [ngModelOptions]="{standalone: true}"></bb-select><span>clips</span></div>

			<bb-table-container *ngIf="rows && rows.length" class="socials-theme">
				<caption>
					{{ (activeTab === 'general' ? 'SYNCHRONISED_CLIPS' : 'FILTER_RESULTS') | translate }}
				</caption>

				<bb-table-header>
					<bb-table-header-cell property="id">{{ 'ID' | translate }}</bb-table-header-cell>
					<bb-table-header-cell property="title">{{ 'TITLE' | translate }}</bb-table-header-cell>
					<bb-table-header-cell property="views">{{ 'VIEWS' | translate }}</bb-table-header-cell>
					<bb-table-header-cell property="synced" class="date">{{ 'DATE_SYNCED' | translate }}</bb-table-header-cell>
					<bb-table-header-cell property="status" class="icon" [ngClass]="{'status-and-stream-status': rowsContainLiveClips}">{{ 'STATUS' | translate}}</bb-table-header-cell>
					<bb-table-header-cell *ngIf="activeTab === 'automated-synching'" class="buttons"></bb-table-header-cell>
				</bb-table-header>
		
				<bb-table-row *ngFor="let row of rows; trackBy: trackBy" [row]="row">
					<bb-table-cell property="id">{{ row.data.id }}</bb-table-cell>
					<bb-table-cell property="title" class="overflow">
						<span [hidden]="!row.data.title">{{ row.data.title }}</span>
						<span [hidden]="row.data.title" class="filename">{{ row.data.originalfilename }}</span>
					</bb-table-cell>
					<bb-table-cell property="views"><a href="{{ row.data.remoteUrl }}">{{ row.data.views }}</a></bb-table-cell>
					<bb-table-cell property="synced">{{ row.data.synched || 'n/a' }}</bb-table-cell>
					<bb-table-cell property="status">
						<span [hidden]="row.data.YouTube_status" class="gray status-new" [innerHTML]="row.data | statusIcon:'social-export'"></span>
						<span [hidden]="row.data.YouTube_status !== 'new'" class="orange status-queued" [innerHTML]="row.data | statusIcon:'social-export'"></span>
						<span [hidden]="row.data.YouTube_status !== 'error'" class="red status-failed" [innerHTML]="row.data | statusIcon:'social-export'"></span>
						<span [hidden]="row.data.YouTube_status !== 'exported'" class="green status-exported" [innerHTML]="row.data | statusIcon:'social-export'"></span>
					</bb-table-cell>
					<bb-table-cell *ngIf="activeTab === 'automated-synching'" class="buttons">
						<a class="button" [ngClass]="{'disabled': !row.data.YouTube_id || row.data.YouTube_status !== 'exported'}" (click)="deleteFromYoutube(row)">
							<i class="fa fa-trash"></i>
						</a><!--
		
						--><a class="button" [ngClass]="{'disabled': !row.data.YouTube_id || row.data.YouTube_status !== 'exported'}" (click)="openClip(row)">
							<i class="fa fa-play-circle"></i>
						</a>
					</bb-table-cell>
				</bb-table-row>
		
			</bb-table-container>
		
			<div *ngIf="rows && !rows.length" class="placeholder-empty">
				<div class="placeholder-empty-image">
					<div class="block">
						<i class="fa-regular fa-film-slash"></i>
					</div>
					<span class="placeholder-text">{{ 'NO_MEDIA_CLIPS_SYNCHRONIZED' | translate }}</span>
					<a class="placeholder-text blue" [routerLink]="['/library/mediaclips']">{{ 'CLICK_HERE_TO_SYNCHRONIZE' | translate }}</a>
				</div>
			</div>
		
			<bb-table-pager *ngIf="rows && rows.length" theme="socials-theme" [total]="rowsTotal"></bb-table-pager>
		
			<bb-entity-details
				[entity]="entity"
			></bb-entity-details>
		</div>
	</div>
</form>

<bb-actions-bar (onSave)="save($event)" (onCancel)="cancel()" (onDelete)="delete($event)" [form]="form" [entity]="entity"></bb-actions-bar>
